// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v5.4.16-2-g3de73c3a975a58d4bea75a2f08ebd9959e90c134",
    "hash": "g3de73c3a975a58d4bea75a2f08ebd9959e90c134",
    "distance": 2,
    "tag": "v5.4.16",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v5.4.16",
        "major": 5,
        "minor": 4,
        "patch": 16,
        "prerelease": [],
        "build": [],
        "version": "5.4.16"
    },
    "suffix": "2-g3de73c3a975a58d4bea75a2f08ebd9959e90c134",
    "semverString": "5.4.16+2.g3de73c3a975a58d4bea75a2f08ebd9959e90c134",
    "version": "5.4.17"
};
/* tslint:enable */
